import axios from "axios";
import store from "../store";
import { logout } from "../store/auth";
import { setToken, setRefreshToken, removeToken, removeUser } from "../functions/TokenFunctions";
import { login } from "../store/auth";
import { refreshTokens } from "./authAPI";

// REACT_APP_API_URL points the app at another API, e.g. the local one in docker-compose.yml.
const API_URL = process.env.REACT_APP_API_URL || "https://api.evocal.kz"

export const http = axios.create({
  baseURL: API_URL,
  timeout: 3000,
  headers: {
    "Content-Type": "application/json",
  }
});

const responseSuccessHandler = response => {
  return response;
};

// Requests that fail with 401 at the same time share one refresh.
let refreshing = null;

const refreshAccessToken = () => {
  if (!refreshing) {
    refreshing = refreshTokens()
      .then((res) => {
        setToken(res.data.access);
        setRefreshToken(res.data.refresh);
        store.dispatch(login({
          user: store.getState().auth.user,
          token: res.data.access,
          refreshToken: res.data.refresh
        }));

        return res.data.access;
      })
      .finally(() => {
        refreshing = null;
      });
  }

  return refreshing;
};

const responseErrorHandler = error => {
  const originalRequest = error.config;
  // Timeouts and network errors come without a response.
  if (!error.response) {
    return Promise.reject(error);
  }

  if ((error.response.status === 401 || error.response.status === 500) && originalRequest.url === `/auth/refresh`) {
    removeToken();
    removeUser();
    store.dispatch(logout());

    return Promise.reject(error);
  }

  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    return refreshAccessToken().then((access) => {
      originalRequest.headers['Authorization'] = `Bearer ${access}`;
      return axios(originalRequest);
    });
  }

  return Promise.reject(error);
};

http.interceptors.response.use(
  response => responseSuccessHandler(response),
  error => responseErrorHandler(error)
);
